
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group",
      function () {
        return require("private-next-pages/group/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/group"])
      });
    }
  